import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account job Management
import { NOTIFICATION, UPDATE_NOTIFICATION } from './actionTypes';
import { notificationFailed, notificationSuccessful, updateNotificationSuccessful, updateNotificationFailed } from './actions';

import { getOrganizationNotifications, updateOrganizationNotifications} from "../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

// get notification list
function* getNotifications({ payload: { pageNumber } }) {
  try {
    let url = constClass.REST_API_GET_ORGANIZATION_NOTIFICATIONS
    var responsJSON = yield call(getOrganizationNotifications, url+"?page="+pageNumber);
    yield put(notificationSuccessful(responsJSON))
  }
  catch (error) {
    yield put(notificationFailed(error))
  }
}


function* updateNotifications({ payload: { ids } }) {
  try {
    let url = constClass.REST_API_UPDATE_ORGANIZATION_NOTIFICATIONS
    var responsJSON = yield call(updateOrganizationNotifications, url, ids);
    yield put(updateNotificationSuccessful(responsJSON))
  }
  catch (error) {
    yield put(updateNotificationFailed(error))
  }
}

export function* functionList() {
  yield takeEvery(UPDATE_NOTIFICATION, updateNotifications);
  yield takeEvery(NOTIFICATION, getNotifications);
}

function* notificationSaga() {
  yield all([fork(functionList)]);
}

export default notificationSaga